import { Amplify } from "aws-amplify";
import { confirmSignIn, confirmUserAttribute, fetchAuthSession, fetchUserAttributes, signIn, updateUserAttribute, signOut, getCurrentUser } from "aws-amplify/auth";

export class CognitoClient {
    static isInitialized = false;

    static initialize(userPoolId, userPoolClientId) {
        // TODO: local storage by default, should we switch to session storage?  
        if (!this.isInitialized) {
            Amplify.configure({ Auth: { Cognito: { userPoolId, userPoolClientId } } });
            this.isInitialized = true;
        }
    }

    static async authenticate(cognitoLogin, clientMetadata) {
        const input = {
            options: {
                authFlowType: "USER_PASSWORD_AUTH",
                clientMetadata
            },
            username: cognitoLogin.username,
            password: cognitoLogin.password
        };

        return await signIn(input);
    }

    static async getCurrentUser() {
        let currentUser;
        try {
            currentUser = await getCurrentUser();
        } catch (_e) {
            console.warn("User not authenticated.")
        }
        return currentUser;
    }

    static async getTokens(clientId) {
        // TODO: COR-6287 Review and potentially refactor
        // amplify no longer returns refresh token so this is a hack to read it from local storage
        // we may want reconsider using refresh token because if aws changes how it is saved
        // to local storage, this will break
        const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
        const lastUser = localStorage.getItem(lastUserKey);
        const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.refreshToken`;
        const refreshToken = localStorage.getItem(refreshTokenKey);

        const sessionData = await fetchAuthSession();
        return { idToken: sessionData.tokens?.idToken, refreshToken };
    }

    static async chooseMfaFactor(mfaFactor) {
        return await confirmSignIn({ challengeResponse: mfaFactor });
    }

    static async confirmOtp(code) {
        return await confirmSignIn({ challengeResponse: code });
    }

    static async confirmTotp(code) {
        return await confirmSignIn({ challengeResponse: code });
    }

    static async confirmNewPassword(newPassword, options) {
        return await confirmSignIn({ challengeResponse: newPassword, options });
    }

    static async getUserAttributes() {
        return await fetchUserAttributes();
    }

    static async updateUserEmail(email) {
        return await updateUserAttribute({ userAttribute: { attributeKey: "email", value: email } });
    }

    static async confirmNewEmail(confirmationCode) {
        return await confirmUserAttribute({ userAttributeKey: "email", confirmationCode });
    }

    static async signOutCurrentUser() {
        return await signOut();
    }
}